import { createFileRoute } from "@tanstack/react-router";
import { notificationSettingsQueryOptions } from "~/features/settings/notifications/api";
import { SettingsTemplate } from "~/features/settings/SettingsTemplate";

export const Route = createFileRoute("/_authenticated/setting/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(notificationSettingsQueryOptions),
  component: SettingsTemplate,
});
